export default '/p/@slug'
